<template>
  <!-- Rent a Car Plugin -->
  <keep-alive>
    <!-- <iframe
        src="https://rada2.us4.hqrentals.app/public/car-rental/reservations/step1?new=1&brand=8qhaqtwr-h3iq-nte6-9faj-5x31dcqqugni"
        id="hq-rental-iframe"
        dd=""
        data-skip_scroll_to_top="1"
        data-hj-allow-iframe=""
        scrolling="yes"
        :style="`overflow:hidden; height: ${imageHeight}px; border:none !important; width: 100%`"
    ></iframe> -->
    <iframe
      :src="`https://rada2.us4.hqrentals.app/public/car-rental/reservations/embed?brand=8qhaqtwr-h3iq-nte6-9faj-5x31dcqqugni&new=true&layout=vertical&forced_locale=${$i18n.locale}`"
      id="hq-rental-iframe"
      dd=""
      data-skip_scroll_to_top=""
      data-hj-allow-iframe=""
      scrolling="yes" 
      :style="`border:none !important; min-height: ${$vuetify.breakpoint.mobile ? 680 : 510 }px; height: 100%; width: 100%`"
      class="custom-iframe"
    ></iframe>
    <!-- <div class="hq-rental-software-integration"     data-integrator_link="https://rada2.us4.hqrentals.app/public/car-rental/integrations"             
        data-brand="8qhaqtwr-h3iq-nte6-9faj-5x31dcqqugni"          data-snippet="reservation-form"     data-skip_language=""               
        data-skip_redirect="1"          data-reservation_page=""          data-layout="vertical"          data-currency=""                         
        data-rate_type_uuid=""          data-referral=""></div> -->
  </keep-alive>
  <!-- ./ Rent a Car Plugin -->
</template>

<script>
import i18n from '@/plugins/i18n'
import { VueTypedJs } from 'vue-typed-js'
export default {
  name:'radaVertical',
  data: function() {
    return {
      imageHeight: 0,
      data_integrator_link: 'https://rada2.us4.hqrentals.app/public/car-rental/integrations',
      data_brand: '8qhaqtwr-h3iq-nte6-9faj-5x31dcqqugni',
      data_snippet: 'reservation-form',
      data_skip_lang: '',
      data_skip_red: '1',
      data_res_page: '',
      data_layout: 'vertical',
      data_curr: '',
      data_rate_type_uuid: '',
      data_ref: '',
      iframe_height: '400',
      iframe_width: '600',
      class_name: 'hq-rental-software-integration',
      iframe_id: 'custom-iframe'
    }
  },
  computed: {
    iframeSrc(){
      // const params = {
      //   data-brand
      // }
    },
    iframeClass(){
      return this.class_name
    }
  },
  mounted() {
    // this.setImageHeight()
    // window.addEventListener('resize', this.setImageHeight)
    // this.buildIframeSrc()
  },
  methods: {
    // setImageHeight() {
    //     this.imageHeight = window.innerHeight
    // }
    // buildIframeSrc() {
    //     const embedCodeDiv = document.querySelector('.hq-rental-software-integration')

    //     const integrator_link = embedCodeDiv.getAttribute('data-integrator_link')
    //     const data_brand = embedCodeDiv.getAttribute('data-brand')
    //     const data_snippet = embedCodeDiv.getAttribute('data-snippet')
    //     const data_skip_lang = embedCodeDiv.getAttribute('data-skip_language')

    //     const data_skip_red = embedCodeDiv.getAttribute('data-skip_redirect')
    //     const data_res_page = embedCodeDiv.getAttribute('data-reservation_page')
    //     const data_layout = embedCodeDiv.getAttribute('data-layout')
    //     const data_curr = embedCodeDiv.getAttribute('data-currency')

    //     const data_rate_type_uuid = embedCodeDiv.getAttribute('data-rate_type_uuid')
    //     const data_ref = embedCodeDiv.getAttribute('data-referral')

    //     // Construir la URL del iframe usando los atributos del div
    //     let src = `${integrator_link}?`;

    //     if (data_brand) {
    //         src += `data-integrator_link=${data_brand}&`;
    //     }
    //     if (data_snippet) {
    //         src += `data-snippet=${data_snippet}&`;
    //     }
    //     if (data_skip_lang) {
    //         src += `data-skip_language=${data_skip_lang}&`;
    //     }
    //     if (data_skip_red) {
    //         src += `data-skip_redirect=${data_skip_red}&`;
    //     }
    //     if (data_res_page) {
    //         src += `data-reservation_page=${data_res_page}&`;
    //     }
    //     if (data_layout) {
    //         src += `data-layout=${data_layout}&`;
    //     }
    //     if (data_curr) {
    //         src += `data-currency=${data_curr}&`;
    //     }
    //     if (data_rate_type_uuid) {
    //         src += `data-rate_type_uuid=${data_rate_type_uuid}&`;
    //     }
    //     if (data_ref) {
    //         src += `data-referral=${data_ref}&`;
    //     }

    //     // Eliminar el último "&" y establecer la URL del iframe
    //     this.iframeSrc = src.slice(0, -1);
    // }
  }
}
</script>

<style scoped>
  .custom-iframe {
    width: 100%;
    display: block;
  }
</style>